
import React from 'react';
import { Link } from 'react-router-dom';

const Section2 = (props) => {
    return (
        <>
            <div className='container-fluid'>
                <div className='row align-items-center text-raleway'>
                <div className={` col-12 section2 ${props.bgClass}`}>
                    <div className='py-md-5 py-3 row justify-content-center align-items-center'>
                        <div className='col-12 py-lg-5 mt-lg-4 col-lg-7'>
                        <div className='bg-white shadow p-lg-5 p-4'>
                        <h2 className='fs-zk-56 text-zk-secondary fw-700'>
                        {props.Title}
                        </h2>
                        <h3 className='fs-zk-40 text-zk-primary fw-700'>
                        {props.SubTitle}
                        </h3>
                        <p className='fs-zk-17 text-poppins fw-400 lh-2 mt-2'>
                        {props.Paragraph}
                        </p>
                    </div>
                    <div className='text-end pt-4 me-5'>
                        {props.button ?
                        <Link to={props.Link} className=' btn btn-zk-secondary fw-400 fs-zk-22 border-0 px-3 py-1 rounded-0 text-capitalize text-white'>
                            Learn More
                        </Link>
                        : 
                            <div className="invisible">
                            <div className='pb-md-2'>Dummy</div>
                            </div>
                        }
                </div>
                        </div>
                        <div className='d-none d-lg-block col-lg-4'>

                        </div>
                    </div>
                </div>
                </div>
            </div>
        </>
    );
}

export default Section2;
